import '@babel/polyfill';
import init from './init.jsx';

init();
